import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

import MaterialButton from './MaterialButton'

interface Props {
	showTitle?: boolean
}

const SuperReaderCape = ({ showTitle }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Super Reader Cape" }) {
				title
				image {
					gatsbyImageData(placeholder: BLURRED)
				}
			}
		}
	`)

	const title = data.contentfulModal.title
	const image = data.contentfulModal.image[0].gatsbyImageData

	return (
		<React.Fragment>
			<MaterialButton onClick={handleShow} image={image} title={title} showTitle={showTitle} />
			<Modal title={title} isOpen={show} handleClose={handleClose}>
				<Row>
					<Col>
						<GatsbyImage image={image} alt={title} />
					</Col>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

export default SuperReaderCape
